import { InsumoEstado } from 'src/utils/enums/InsumoEstado';
import { InsumoFormState } from './types';
import {
  verificarInsumoF,
  discontinuarInsumoF,
  actualizarInsumoPrecio,
  estimarInsumoPrecioF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';
import { colorMapping } from 'src/utils/enums/InsumoEstado';

const initialState: InsumoFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'insumoForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },
    setFormStatusBorrador(state) {
      state.status = {
        id: InsumoEstado.Borrador,
        text: InsumoEstado[InsumoEstado.Borrador].toUpperCase(),
        color: colorMapping[InsumoEstado.Borrador],
      };
      state.data = {
        codigo: { readOnly: false },
        descripcion: { readOnly: false },
        ultimaActualizacion: {
          readOnly: true,
          placeholder: 'Se modifica mediante el botón Actualizar.',
          visible: false,
        },
        ultimaCompra: {
          readOnly: true,
          placeholder: 'Se modifica mediante el botón Actualizar.',
          visible: false,
        },
        actualizadoAMano: { readOnly: true, visible: false },
        cantidadTotal: { readOnly: true, visible: false },
        unidadDeConsumoId: { readOnly: false },
        precioUnitarioUnificado: { readOnly: true, visible: false },
        estado: { readOnly: false },
        monedaId: { readOnly: false },
        proveedorId: { readOnly: false },
        tipoInsumoId: { readOnly: false },
      };

      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        comprarInsumo: {
          visible: false,
          disabled: false,
          tooltip: 'Comprar insumo',
        },

        verificarInsumoF: {
          visible: true,
          disabled: true,
          tooltip: 'Verificar al insumo',
        },
        discontinuarInsumoF: {
          visible: true,
          disabled: true,
          tooltip: 'Discontinuar al insumo',
        },
        actualizarInsumoPrecio: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar precio del insumo',
        },
        estimarInsumoPrecioF: {
          visible: false, //no visible porque aún no se desarrolló la funcionalidad
          disabled: true,
          tooltip: 'Estimar precio del insumo',
        },
      };
    },
    setFormStatusVerificadoYActualizado(state) {
      state.status = {
        id: InsumoEstado.VerificadoYActualizado,
        text: InsumoEstado[InsumoEstado.VerificadoYActualizado].toUpperCase(),
        color: colorMapping[InsumoEstado.VerificadoYActualizado],
      };
      state.data = {
        codigo: { readOnly: true },
        descripcion: { readOnly: false },
        ultimaActualizacion: {
          readOnly: true,
          placeholder: 'Se modifica mediante el botón Actualizar.',
        },
        ultimaCompra: {
          readOnly: true,
          placeholder: 'No se encontró una compra reciente.',
        },
        actualizadoAMano: { readOnly: true },
        cantidadTotal: { readOnly: true },
        unidadDeConsumoId: { readOnly: false },
        precioUnitarioUnificado: { readOnly: true },
        estado: { readOnly: false },
        monedaId: { readOnly: false },
        proveedorId: { readOnly: false },
        tipoInsumoId: { readOnly: false },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        comprarInsumo: {
          visible: true,
          disabled: false,
          tooltip: 'Comprar insumo',
        },

        verificarInsumoF: {
          visible: false,
          disabled: false,
          tooltip: 'Verificar al insumo',
        },
        discontinuarInsumoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al insumo',
        },
        actualizarInsumoPrecio: {
          visible: true,
          disabled: false,
          tooltip: 'Actualizar precio del insumo',
        },
        estimarInsumoPrecioF: {
          visible: false, //no visible porque aún no se desarrolló la funcionalidad
          disabled: false,
          tooltip: 'Estimar precio del insumo',
        },
      };
    },
    setFormStatusVerificadoYDesactualizado(state) {
      state.status = {
        id: InsumoEstado.VerificadoYDesactualizado,
        text: InsumoEstado[
          InsumoEstado.VerificadoYDesactualizado
        ].toUpperCase(),
        color: colorMapping[InsumoEstado.VerificadoYDesactualizado],
      };
      state.data = {
        codigo: { readOnly: true },
        descripcion: { readOnly: false },
        ultimaActualizacion: {
          readOnly: true,
          placeholder: 'Se modifica mediante el botón Actualizar.',
        },
        ultimaCompra: {
          readOnly: true,
          placeholder: 'No se encontró una compra reciente.',
        },
        actualizadoAMano: { readOnly: true },
        cantidadTotal: { readOnly: true },
        unidadDeConsumoId: { readOnly: false },
        precioUnitarioUnificado: { readOnly: true },
        estado: { readOnly: false },
        monedaId: { readOnly: false },
        proveedorId: { readOnly: false },
        tipoInsumoId: { readOnly: false },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        comprarInsumo: {
          visible: true,
          disabled: false,
          tooltip: 'Comprar insumo',
        },

        verificarInsumoF: {
          visible: false,
          disabled: false,
          tooltip: 'Verificar al insumo',
        },
        discontinuarInsumoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al insumo',
        },
        actualizarInsumoPrecio: {
          visible: true,
          disabled: false,
          tooltip: 'Actualizar precio del insumo',
        },
        estimarInsumoPrecioF: {
          visible: false, //no visible porque aún no se desarrolló la funcionalidad
          disabled: false,
          tooltip: 'Estimar precio del insumo',
        },
      };
    },
    setFormStatusDiscontinuado(state) {
      state.status = {
        id: InsumoEstado.Discontinuado,
        text: InsumoEstado[InsumoEstado.Discontinuado].toUpperCase(),
        color: colorMapping[InsumoEstado.Discontinuado],
      };
      state.data = {
        codigo: { readOnly: true },
        descripcion: { readOnly: false },
        ultimaActualizacion: {
          readOnly: true,
          placeholder: 'Se modifica mediante el botón Actualizar.',
        },
        ultimaCompra: {
          readOnly: true,
          placeholder: 'No se encontró una compra reciente.',
        },
        actualizadoAMano: { readOnly: true },
        cantidadTotal: { readOnly: true },
        unidadDeConsumoId: { readOnly: false },
        precioUnitarioUnificado: { readOnly: true },
        estado: { readOnly: false },
        monedaId: { readOnly: false },
        proveedorId: { readOnly: false },
        tipoInsumoId: { readOnly: false },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        comprarInsumo: {
          visible: true,
          disabled: true,
          tooltip: 'Comprar insumo',
        },

        verificarInsumoF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar al insumo',
        },
        discontinuarInsumoF: {
          visible: false,
          disabled: false,
          tooltip: 'Discontinuar al insumo',
        },
        actualizarInsumoPrecio: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar precio del insumo',
        },
        estimarInsumoPrecioF: {
          visible: false, //no visible porque aún no se desarrolló la funcionalidad
          disabled: true,
          tooltip: 'Estimar precio del insumo',
        },
      };
    },
    setFormStatusNoVerificado(state) {
      state.status = {
        id: InsumoEstado.NoVerificado,
        text: InsumoEstado[InsumoEstado.NoVerificado].toUpperCase(),
        color: colorMapping[InsumoEstado.NoVerificado],
      };
      state.data = {
        codigo: { readOnly: true },
        descripcion: { readOnly: false },
        ultimaActualizacion: {
          readOnly: true,
          placeholder: 'Se modifica mediante el botón Actualizar.',
        },
        ultimaCompra: {
          readOnly: true,
          placeholder: 'No se encontró una compra reciente.',
        },
        actualizadoAMano: { readOnly: true },
        cantidadTotal: { readOnly: true },
        unidadDeConsumoId: { readOnly: false },
        precioUnitarioUnificado: { readOnly: true },
        estado: { readOnly: false },
        monedaId: { readOnly: false },
        proveedorId: { readOnly: false },
        tipoInsumoId: { readOnly: false },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        comprarInsumo: {
          visible: true,
          disabled: true,
          tooltip: 'Comprar insumo',
        },

        verificarInsumoF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar al insumo',
        },
        discontinuarInsumoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al insumo',
        },
        actualizarInsumoPrecio: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar precio del insumo',
        },
        estimarInsumoPrecioF: {
          visible: false, //no visible porque aún no se desarrolló la funcionalidad
          disabled: true,
          tooltip: 'Estimar precio del insumo',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verificarInsumoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(verificarInsumoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(discontinuarInsumoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(discontinuarInsumoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(actualizarInsumoPrecio.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(actualizarInsumoPrecio.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(estimarInsumoPrecioF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(estimarInsumoPrecioF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) => state.insumo.form.status;

export const selectComprarInsumo = (state: RootState) =>
  state.insumo.form.actions?.comprarInsumo;

export const selectVerificarInsumoF = (state: RootState) =>
  state.insumo.form.actions?.verificarInsumoF;

export const selectDiscontinuarInsumoF = (state: RootState) =>
  state.insumo.form.actions?.discontinuarInsumoF;

export const selectActualizarInsumoPrecio = (state: RootState) =>
  state.insumo.form.actions?.actualizarInsumoPrecio;

export const selectEstimarInsumoPrecioF = (state: RootState) =>
  state.insumo.form.actions?.estimarInsumoPrecioF;

export const selectGuardar = (state: RootState) =>
  state.insumo.form.actions?.guardar;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusVerificadoYActualizado,
  setFormStatusVerificadoYDesactualizado,
  setFormStatusDiscontinuado,
  setFormStatusNoVerificado,
} = formSlice.actions;

export default formSlice.reducer;
